import request from "../request";
// 获取助推列表
export function getBoostList(data) {
  return request({
    url: "/ld/ksStarVideoSupplementOrder/getListData",
    method: "post",
    data,
  });
}

// 修改出价
export function ModifyBid(data) {
  return request({
    url: "/ld/ksStarVideoSupplementOrder/supplementOrderUnitPriceUpdate",
    method: "post",
    data,
    headers: {
      "Content-Type": "application/json",
    },
  });
}

// 修改预算
export function modifyBudget(data) {
  return request({
    url: "/ld/ksStarVideoSupplementOrder/supplementOrderPromotionAmountUpgrade",
    method: "post",
    data,
    headers: {
      "Content-Type": "application/json", // 设置为JSON格式
    },
  });
}

// 修改投放时间
export function ReleaseTime(data) {
  return request({
    url: "/ld/ksStarVideoSupplementOrder/supplementOrderPromotionEndtimeUpdate",
    method: "post",
    data,
    headers: {
      "Content-Type": "application/json", // 设置为JSON格式
    },
  });
}

// 结束助推
export function EndBoost(data) {
  return request({
    url: "/ld/ksStarVideoSupplementOrder/supplementOrderStarVideoFinish",
    method: "post",
    data,
    headers: {
      "Content-Type": "application/json",
    },
  });
}

// 取消发送
export function CancelBoostsOrder(data) {
  return request({
    url: "/ld/ksStarVideoSupplementOrder/supplementOrderPromotionCancelSend",
    method: "post",
    data,
    headers: {
      "Content-Type": "application/json",
    },
  });
}

// 批量复制
export function BatchCopy(data) {
  return request({
    url: "/ld/ksStarVideoSupplementOrder/supplementOrderStarVideoCreateCopy",
    method: "post",
    data,
    headers: {
      "Content-Type": "application/json", // 设置为JSON格式
    },
  });
}

// 字典
export function Dictionary(data) {
  return request({
    url: "/ld/auth/getDictList",
    method: "post",
    data,
    noPrefix: true,
  });
}

export default {
  getBoostList,
  modifyBudget,
  ModifyBid,
  EndBoost,
  CancelBoostsOrder,
  ReleaseTime,
  BatchCopy,
  Dictionary,
};
